import React, { Component } from 'react'

import request from 'axios'
import { baseURL } from 'core/constants'
import { isValidIntegerInRange, toIntegerOrRaw } from 'utils/utils'
import Space from 'components/lib/Space'
import Button from 'components/lib/Button'

import OwnershipDate from './OwnershipDate'
import Settings from './Settings'
import Payday from './Payday'
import ValidityMonths from './ValidityMonths'

class Options extends Component {
  constructor(props) {
    super(props)
    this.state = {
      date: null,
      keysLocation: '',
      guaranteeValue: '',
      payday: props.defaultValue.payday,
      validityMonths: props.defaultValue.validity_months,
      validate: {
        payday: true,
        validity_months: true,
      },
    }
  }

  render() {
    const {
      proposalId,
      processId,
      dataValue,
      onSuccess,
      defaultValue,
      showGuaranteeValue,
      maxLength,
      allowMaxLengthField,
    } = this.props

    const { keysLocation } = this.state

    return (
      <>
        <div className='flex-form'>
          <Payday
            defaultValue={this.props.defaultValue.payday}
            disabledAutoFocus
            onChange={(e) => {
              this.setState({ payday: e })
            }}
            isValid={this.state.validate.payday}
            errorMessage='O Dia de Pagamento deve ser um número entre 1 e 31'
          />
          {this.props.isRental && (
            <ValidityMonths
              defaultValue={this.props.defaultValue.validityMonths}
              disabledAutoFocus
              onChange={(e) => {
                this.setState({ validityMonths: e })
              }}
              isValid={this.state.validate.validity_months}
              errorMessage='A Vigência deve ser um número maior que 0'
            />
          )}
        </div>

        <Space isSmall />

        <OwnershipDate
          processId={processId}
          dataValue={dataValue}
          disabledAutoFocus
          onSuccess={onSuccess}
          changeDate={(e) => this.changeDate(e)}
        />

        <Space isSmall />

        <Settings
          defaultValue={defaultValue}
          showGuaranteeValue={showGuaranteeValue}
          disabledAutoFocus
          maxLength={maxLength}
          currentFieldLength={this.state.keysLocation.length}
          allowMaxLengthField={allowMaxLengthField}
          changeKeysLocation={(e) => this.changeKeysLocation(e)}
          changeGuaranteeValue={(e) => this.changeGuaranteeValue(e)}
        />

        <Space isSmall />

        <div className='text-right'>
          <Button
            isLoading={this.state.isWorking}
            hasThemeColor
            onClick={() => this.submitOptions()}
            isDisabled={keysLocation.length > maxLength}
          >
            Salvar
          </Button>
        </div>
      </>
    )
  }

  changeDate(date) {
    this.setState({ date })
  }

  changeKeysLocation(keysLocation) {
    this.setState({ keysLocation })
  }

  changeGuaranteeValue(guaranteeValue) {
    this.setState({ guaranteeValue })
  }

  saveDateOwnership(date) {
    if (this.state.date)
      return request.post(
        `${baseURL}company/${this.props.company.id}/process/${this.props.processId}/overview/define-ownership-date`,
        { ownership_date: date },
      )
  }

  saveGuaranteeValue(guaranteeValue) {
    const guarantee_value = {
      guarantee_value: parseFloat(
        guaranteeValue.replace(/\./g, '').replace(',', '.'),
      ),
    }

    return request.post(
      `${baseURL}company/${this.props.company.id}/process/${this.props.processId}/overview/set-guarantee-value`,
      guarantee_value,
    )
  }

  savekeysLocation(keysLocation) {
    return request.post(
      `${baseURL}company/${this.props.company.id}/process/${this.props.processId}/overview/set-keys-location`,
      { keys_location: keysLocation },
    )
  }

  savePaydayValidityMonths() {
    return request.put(
      `${baseURL}company/${this.props.company.id}/proposal/${this.props.proposalId}`,
      {
        payday: toIntegerOrRaw(this.state.payday),
        validity_months: toIntegerOrRaw(this.state.validityMonths),
      },
    )
  }

  validateForm() {
    const validate = {
      payday: isValidIntegerInRange(this.state.payday, 1, 31),
      validity_months: isValidIntegerInRange(this.state.validityMonths, 1),
    }

    this.setState({ validate })

    return validate.payday && validate.validity_months
  }

  submitOptions() {
    if (!this.validateForm()) return

    this.setState({ isWorking: true })

    const { showGuaranteeValue } = this.props
    const { date, keysLocation, guaranteeValue } = this.state

    const promises = []

    promises.push(this.saveDateOwnership(date))
    promises.push(this.savekeysLocation(keysLocation))
    promises.push(this.savePaydayValidityMonths())

    if (showGuaranteeValue) promises.push(this.saveGuaranteeValue(guaranteeValue))

    Promise.all(promises)
      .then(() => this.props.onSuccess({ isSuccess: true }))
      .catch((error) => {
        const message =
          error?.response?.data?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          'Ocorreu um erro ao tentar atualizar a configuração'
        this.props.onSuccess({ isSuccess: false, message })
      })
      .finally(() => this.setState({ isWorking: false }))
  }
}

export default Options
